export const config = {
    authority: 'https://id-test.locate2u.com/',
    redirect_uri: 'https://app-test.locate2u.com/callback',
    post_logout_redirect_uri: 'https://app-test.locate2u.com/login',
    silent_redirect_uri: 'https://app-test.locate2u.com/static/silent-renew.html',
    billing_redirect_url: 'https://app-test.locate2u.com/dashboard',
    billing_customer_portal_url: 'https://billing.test.locate2u.com'
};
